import React, { Suspense, useEffect, useLayoutEffect, useState } from "react";
import AppContainer from "../util/AppContainer";
import MenuSearch from "./MenuSearch";
import MenuTopBar from "./MenuTopBar";
import styles from "./Menu.module.css";
import MenuTypeFilter from "./MenuTypeFilter";
import MenuCategories from "./MenuCategories";
import BrowseMenuButton from "./BrowseMenuButton";
import { useDispatch, useSelector } from "react-redux";
import { fetchChefMenu } from "../../store/menuActions";
import ModelSaff from "../search/ModelStaff";
import ModelCuisines from "../search/ModelCuisines";
import { bottomBarActions } from "../../store/bottomBarSlice";
import { loginActions } from "../../store/loginSlice";
import "./browse-menu-button.css";
import { updateDishCheckedInUser, updateUser } from "../../store/loginActions";
import { ToastContainer } from "react-toastify";
import { underconstructionActions } from "../../store/underconstructionslice";
import { chefActions } from "../../store/chefSlice";
import ReactGA from "react-ga4";
import { referActions } from "../../store/referSlice";
import mixpanel from "mixpanel-browser";
import useDetectKeyboardOpen from "use-detect-keyboard-open";
import Joyride from "react-joyride";
import { menuActions } from "../../store/menuSlice";
import ScheduleOrderButton from "../ScheduleOrderButton/Index";
import { SuspenseImg } from "../util/SuspendImg";
import ImageLoader from "../chef/ImageLoader";
// import clevertap from "clevertap-web-sdk";

const steps = [
  {
    title: "You can schedule the order from here",
    content: "Schedule order and get your order delivered on time",
    spotlightPadding: 0,
    placement: 'bottom-start',
    locale: {
      last: "Got it",
    },
    target: ".scheduleOrderButton",
    disableBeacon: true,
  },
];

const Menu = (props) => {
  const isKeyboardOpen = useDetectKeyboardOpen();

  useEffect(() => {
    // ReactGA.send({ hitType: "pageview", page: "/menu" });
    ReactGA.event({
      category: "tab",
      action: "menu",
    });
  }, []);

  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState();
  const [browseValue, setBrowseValue] = useState({ model: false, value: "" });
  const [showOpenValidation, setShowOpenValidation] = useState(false);
  const [showDishPriceValidation, setShowDishPriceValidation] = useState(false);
  const menuDetails = useSelector((state) => state.menu.menuDetails);
  const menuLoaded = useSelector((state) => state.menu.menuLoaded);
  const singleStorie = useSelector((state) => state.bottomBar.storie);
  const demoForUnlockMenu = useSelector(
    (state) => state.menu.demoForUnlockMenu
  );
  const setDemoForUnlockMenu = useSelector(
    (state) => state.menu.setDemoForUnlockMenu
  );
  const [categoriesdata, setCategoriesdata] = useState([]);
  const [showAddedItemPopup, setShowAddedItemPopup] = useState(false);
  const user = useSelector(({ auth }) => auth.user);
  const { cartData, totalCost } = useSelector(({ cart }) => cart);
  const [message, setMessage] = useState("");
  const [action, setAction] = useState(() => { });
  const [button, setButton] = useState("");
  const scheduleTooltipFinished = localStorage.getItem("scheduleTooltipFinished")
  const [run, setRun] = useState();
  
  useEffect(() =>{
    if(scheduleTooltipFinished){
      setRun(false)
    }
  },[scheduleTooltipFinished])


  console.warn(demoForUnlockMenu, setDemoForUnlockMenu);

  useEffect(() => {
    if (totalCost !== 0) {
      setShowAddedItemPopup(true);
      setShowOpenValidation(false);
      setShowDishPriceValidation(false);
    } else {
      setShowAddedItemPopup(false);
    }
  }, [totalCost]);

  const showCart = () => {
    dispatch(bottomBarActions.loadTab({ tabName: "cart" }));
    dispatch(chefActions.onRedirect());
    mixpanel.track("menu-view-cart-clicked");
    // clevertap.event.push("menu-view-cart-clicked");
  };

  const freeMenuOpens = useSelector((state) => state.auth.freeMenuOpens);
  const freeMenuidsOpened = useSelector(
    (state) => state.auth.freeMenuidsOpened
  );
  const FREE_OPENS = user.maxDishes ? user.maxDishes : 2;
  const FREE_OPENS_AFTER_SIGNUP = user.maxChefs ? user.maxChefs : 4;
  const FREE_DISH_OPENS = user.maxDishPrices ? user.maxDishPrices : 10;

  let askToOpenWithoutSignup = !user.referral && freeMenuOpens < FREE_OPENS;
  let askForSignup = !user.referral && freeMenuOpens >= FREE_OPENS;

  let askToOpenWithSignup =
    user.referral && user.menuOpens < FREE_OPENS_AFTER_SIGNUP;
  let askForRefferal =
    user.referral && user.menuOpens >= FREE_OPENS_AFTER_SIGNUP;

  let askForSignupToCheckPrice = !user.referral;
  let askForRefferalToCheckPrice = false;
  //user.referral && user.dishPriceChecked >= FREE_DISH_OPENS;
  let showFreeDishCheckPriceRemaining =
    user.referral && user.dishPriceChecked < FREE_DISH_OPENS;

  const showSignUp = () => {
    dispatch(bottomBarActions.loadTab({ tabName: "account" }));
    dispatch(bottomBarActions.updateFrom({ from: "cart" }));
    mixpanel.track("show-signup-clicked");
    // clevertap.event.push("show-signup-clicked");
  };

  const showUnderConstruction = () => {
    dispatch(bottomBarActions.hideMenu());
    dispatch(chefActions.onBackClick());
    dispatch(underconstructionActions.onSearchClick());
  };

  const showReferView = () => {
    // dispatch(chefActions.onRedirect());
    dispatch(bottomBarActions.hideMenu());
    dispatch(referActions.onReferClick({ from: "chef" }));
    mixpanel.track("show-refer-clicked");
    // clevertap.event.push("show-refer-clicked");
  };

  const openMenu = () => {
    if (user.referral) {
      dispatch(updateUser(user, menuDetails._id, "menu"));
      setShowOpenValidation(false);
    } else {
      dispatch(loginActions.openFreeMenu(menuDetails._id));
      setShowOpenValidation(false);
    }
    mixpanel.track("open-menu-clicked");
    // clevertap.event.push("open-menu-clicked");
  };

  const validateMenuOpens = () => {
    if (freeMenuidsOpened.includes(menuDetails._id)) {
      setShowOpenValidation(false);
    } else if (user.menuIdsOpened.includes(menuDetails._id)) {
      setShowOpenValidation(false);
    } else {
      if (
        askToOpenWithoutSignup ||
        askForSignup ||
        askToOpenWithSignup ||
        askForRefferal
      ) {
        setShowOpenValidation(true);
        formValidationMessage(true, false);
        mixpanel.track("unlock-menu-shown");
        // clevertap.event.push("unlock-menu-shown");
      }
    }
  };

  const browseMenuAction = () => {
    if (askForSignupToCheckPrice) {
      setShowDishPriceValidation(true);
      formValidationMessage(false, true);
    } else if (askForRefferalToCheckPrice) {
      setShowDishPriceValidation(true);
      formValidationMessage(false, true);
    } else if (freeMenuidsOpened.includes(menuDetails._id)) {
      setShowOpenValidation(false);
      setModalShow(true);
    } else if (user.menuIdsOpened.includes(menuDetails._id)) {
      setShowOpenValidation(false);
      setModalShow(true);
    } else {
      if (
        askToOpenWithoutSignup ||
        askForSignup ||
        askToOpenWithSignup ||
        askForRefferal
      ) {
        setShowOpenValidation(true);
        formValidationMessage(true, false);
        mixpanel.track("unlock-menu-shown");
        // clevertap.event.push("unlock-menu-shown");
      } else {
        setModalShow(true);
      }
    }
  };

  const validateDishPriceCheck = () => {
    if (askForSignupToCheckPrice) {
      setShowDishPriceValidation(false);
      formValidationMessage(false, true);
      return false;
    } else if (askForRefferalToCheckPrice) {
      setShowDishPriceValidation(true);
      formValidationMessage(false, true);
      return false;
    } else {
      setShowDishPriceValidation(false);
      return true;
    }
  };

  const onCheckPrice = async (dishID, setShowAdd) => {
    if (validateDishPriceCheck()) {
      dispatch(updateDishCheckedInUser(user, dishID));
      setShowAdd(true);
    }
    //call pricing api to get current price
  };

  const formValidationMessage = (openValidation, priceValidation) => {
    if (openValidation || showOpenValidation) {
      if (askToOpenWithoutSignup) {
        let freeOpens = FREE_OPENS - freeMenuOpens;
        let menu = freeOpens == 1 ? "menu" : "menus";
        let chef = freeOpens == 1 ? " chef" : " chefs";
        setMessage(
          "You can unlock " +
          menu +
          " of " +
          freeOpens +
          chef +
          " before login"
        );
        setAction(() => openMenu);
        setButton("Unlock Menu");
      } else if (askToOpenWithSignup) {
        let freeOpens = FREE_OPENS_AFTER_SIGNUP - user.menuOpens;
        let menu = freeOpens == 1 ? "menu" : "menus";
        let chef = freeOpens == 1 ? "chef" : "chefs";
        setMessage(
          "You can unlock " + menu + " of " + freeOpens + " more " + chef
        );
        setAction(() => openMenu);
        setButton("Unlock Menu");
      } else if (askForSignup) {
        let freeOpens = FREE_OPENS_AFTER_SIGNUP - FREE_OPENS;
        let menu = freeOpens == 1 ? "menu" : "menus";
        let chef = freeOpens == 1 ? "chef" : "chefs";
        setMessage(
          "You can unlock " +
          menu +
          " of " +
          freeOpens +
          " more " +
          chef +
          " on login"
        );
        setAction(() => showSignUp);
        setButton("Login");
      } else if (askForRefferal) {
        let freeOpens = FREE_OPENS_AFTER_SIGNUP;
        let menu = freeOpens == 1 ? "menu" : "menus";
        let chef = freeOpens == 1 ? "chef" : "chefs";
        setMessage(
          "You can unlock " +
          menu +
          " of " +
          FREE_OPENS_AFTER_SIGNUP +
          " more " +
          chef +
          " on Referral"
        );
        setAction(() => showReferView);
        setButton("Refer");
      }
    } else if (priceValidation || showDishPriceValidation) {
      if (askForSignupToCheckPrice) {
        setMessage("Login to check current price of dishes");
        setAction(() => showSignUp);
        setButton("Login");
      } else if (askForRefferalToCheckPrice) {
        setMessage("Refer your friends to check more dish prices");
        setAction(() => showReferView);
        setButton("Refer");
      } else if (showFreeDishCheckPriceRemaining) {
        let freeOpens = FREE_DISH_OPENS - user.dishPriceChecked;
        let dish = (freeOpens = 1 ? "dish" : "dishes");
        setMessage(
          "Check current price of up to " +
          (FREE_DISH_OPENS - user.dishPriceChecked) +
          " " +
          dish
        );
        setAction(() => validateDishPriceCheck);
        setButton("Okay");
      }
    }
  };

  useEffect(() => {
    if (menuDetails?.categories) {
      setCategoriesdata(menuDetails?.categories);
    }
  }, [menuDetails?.categories]);

  useEffect(() => {
    if (showFreeDishCheckPriceRemaining) {
      formValidationMessage(false, true);
    }
  }, [showFreeDishCheckPriceRemaining]);

  let chefId = props.chefId;
  useEffect(() => {
    if(menuDetails?.chefId !== chefId){
      dispatch(fetchChefMenu(chefId));
    }
  }, [dispatch]);

  const handleJoyrideCallback = (data) => {
    const { action } = data;
    console.log('action', action)
    if(["next", "close"].includes(action)){
      localStorage.setItem("scheduleTooltipFinished", true)
    }
    if (action == "close") dispatch(menuActions.setDemoForUnlockMenu());
  };
  
  const totalPortions = cartData.reduce((acc, cartItem) => {
    return acc + cartItem.portion;
  }, 0);

  useEffect(()=>{
    setRun(true);
  },[])
console.log('menuLoaded', menuLoaded, categoriesdata)
  return (
    <AppContainer>
      {menuLoaded && (
        <MenuTopBar
          name={"Chef " + menuDetails.name}
          cuisine={menuDetails.cuisine}
        />
      )}
      <div
        //onClick={user.maxDishes !== 0 && validateMenuOpens} //TO-DO: Restriction
        className={`${styles["page-inner"]} + ${
          showOpenValidation ? styles["opaque"] : ""
        }`}
      >
        <Joyride
          disableScrollParentFix={true}
          callback={handleJoyrideCallback}
          continuous={true}
          run={!scheduleTooltipFinished && run && !singleStorie}
          
          scrollToFirstStep={true}
          showProgress={false}
          showSkipButton={false}
          steps={steps}
          disableOverlay={true}
          hideBackButton={true}
          disableScrolling={true}
          styles={{
            options: {
              arrowColor: "#F8EDD5",
              primaryColor: "#e8814d",
              zIndex: 10000,
              backgroundColor: "#F8EDD5",
              overlayColor: "rgba(0, 0, 0, 0.6)",
            },
            tooltip: {
              width: "350px"
            },
            tooltipTitle: {
              fontSize: 16,
              margin: "0 0 0px 0",
              textAlign: "left",
              paddingLeft: "10px",
              color: "#670000",
            },
            tooltipContent: {
              fontSize: 13,
              padding: "10px 10px",
              textAlign: "left",
              fontWeight: 300,
              color: "#670000",
            },
            buttonNext: {
              fontSize: "13px",
            },
          }}
        />
        <MenuSearch
          categories={menuDetails.categories}
          setCategoriesdata={setCategoriesdata}
        />
        <MenuTypeFilter
          allCategorie={menuDetails.categories}
          categories={categoriesdata}
          setCategoriesdata={setCategoriesdata}
        />
        {menuLoaded ? (
          <MenuCategories
            categories={categoriesdata}
            saff={false}
            onCheckPrice={onCheckPrice}
            setShowAddedItemPopup={setShowAddedItemPopup}
            parentComponent="chef"
          />
        ) : <ImageLoader className="loader_wrapper" />}
      </div>
      {!isKeyboardOpen && (
        <BrowseMenuButton
          className="brwose-menu-btn"
          setModalShow={setModalShow}
          showOpenValidation={showOpenValidation}
          hideSpace={
            showOpenValidation || showDishPriceValidation || showAddedItemPopup
          }
          setShowOpenValidation={setShowOpenValidation}
          validateMenuOpens={validateMenuOpens}
        />
      )}

      <ModelSaff
        show={modalShow}
        setBrowseValue={setBrowseValue}
        categories={categoriesdata}
        setModalShow={setModalShow}
      />
      {/* <ModelCuisines
        browseValue={browseValue}
        setBrowseValue={setBrowseValue}
      /> */}
      {!isKeyboardOpen && (
        <div
          className={
            showOpenValidation || showDishPriceValidation || showAddedItemPopup
              ? "browser-snackbar active"
              : "browser-snackbar deactive"
          }
          id="cart_option"
        >
          <div
            onClick={
              !showOpenValidation &&
                !showDishPriceValidation &&
                showAddedItemPopup
                ? showCart
                : action
            }
            className="browser-snackbar-detail"
          >
            <ul className="footer-list">
              <li className="list-item-options">
                <a href="#" className="menu-link">
                  {!showOpenValidation &&
                    !showDishPriceValidation &&
                    showAddedItemPopup && (
                      <div className="total-price-container">
                        <span style={{ margin: 0 }}>
                          {totalPortions} {totalPortions == 1 ? "Item" : "Items"} Added
                        </span>

                        <span onClick={showCart}>
                          View Cart
                          <img
                            src="images/icon-view-cart.svg"
                            alt="view-cart"
                            loading="lazy"
                          />
                        </span>
                      </div>
                    )}
                  {(showOpenValidation || showDishPriceValidation) && (
                    <span>{button}</span>
                  )}
                </a>
              </li>
              {(showOpenValidation || showDishPriceValidation) && (
                <li className="list-item-description">
                  <div className="total-items">
                    <a href="#" className="cart-items">
                      <span>{message}</span>
                    </a>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
      )}
      <ToastContainer limit={1} />
    </AppContainer>
  );
};

export default Menu;
